import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "2026-10-01" -> Date at UTC midnight (API dates are plain calendar dates). */
export const parseDate = (s: string) => new Date(`${s}T00:00:00Z`);

/** "Oct 1, 2026" */
export function fmtDate(s: string | null | undefined) {
  if (!s) return '';
  const d = parseDate(s.slice(0, 10));
  return `${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()}, ${d.getUTCFullYear()}`;
}

/** "Oct 2026" */
export function fmtMonth(s: string) {
  const d = parseDate(s);
  return `${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}

/** "Oct 2026 to Nov 2026", or "Oct to Nov 2026" in one year. */
export function fmtWindow(start: string, end: string) {
  const a = parseDate(start);
  const b = parseDate(end);
  if (a.getUTCFullYear() === b.getUTCFullYear()) {
    return a.getUTCMonth() === b.getUTCMonth()
      ? fmtMonth(start)
      : `${MONTHS[a.getUTCMonth()]} to ${MONTHS[b.getUTCMonth()]} ${b.getUTCFullYear()}`;
  }
  return `${fmtMonth(start)} to ${fmtMonth(end)}`;
}

export function fmtDateTime(iso: string | null | undefined) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function fmtRelative(iso: string | null | undefined) {
  if (!iso) return 'Never';
  const ms = Date.now() - new Date(iso).getTime();
  const m = Math.round(ms / 60000);
  if (m < 1) return 'Just now';
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} h ago`;
  const days = Math.round(h / 24);
  if (days < 30) return `${days} d ago`;
  return fmtDateTime(iso);
}

export function initials(name: string) {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join('');
}
